// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gFI_","colMin":"styles_colMin__37ZDA"};